import React, { useEffect, useRef, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { db } from '../../firebaseConfig'; 
import './CSS/TeacherTwitchStreamDisplay.css'; // Vous pouvez garder votre fichier CSS
import NoLiveImg from '../../img/NoLiveStream.png';
import { Typography } from '@mui/material';
import { useTranslation } from "react-i18next";

const TeacherTwitchStreamDisplay = () => {
  const { t } = useTranslation();
  const { groupId } = useParams(); // Récupère l'ID du groupe depuis l'URL
  const [channel, setChannel] = useState(null);
  const embedRef = useRef(null);

  /**
   * 1) Récupération du channel depuis Firestore
   */
  useEffect(() => {
    async function fetchChannel() {
      try {
        // Récupérer le document du groupe
        const groupDocRef = doc(db, 'groups', groupId);
        const groupSnap = await getDoc(groupDocRef);

        if (groupSnap.exists()) {
          const groupData = groupSnap.data();
          const teacherId = groupData.teacherId;
          if (teacherId) {
            // Récupérer le document du professeur correspondant
            const teacherDocRef = doc(db, 'teachers', teacherId);
            const teacherSnap = await getDoc(teacherDocRef);
            if (teacherSnap.exists()) {
              const teacherData = teacherSnap.data();
              if (teacherData.channel) {
                setChannel(teacherData.channel);
              }
            }
          }
        }
      } catch (err) {
        console.error("Erreur lors de la récupération du channel:", err);
      }
    }

    if (groupId) {
      fetchChannel();
    }
  }, [groupId]);

  /**
   * 2) Initialisation du lecteur Twitch
   */
  useEffect(() => {
    if (!channel) return; // N'initialise pas le lecteur tant qu'on n'a pas le channel

    const script = document.createElement('script');
    script.src = "https://embed.twitch.tv/embed/v1.js";
    script.async = true;
    script.onload = () => {
      if (window.Twitch && window.Twitch.Embed) {
        new window.Twitch.Embed(embedRef.current, {
          width: '100%',
          height: '100%',
          channel: channel,
          layout: 'video', // Pour n'afficher que la vidéo
          parent: [window.location.hostname]
        });
      }
    };
    document.body.appendChild(script);

    // Nettoyage : retire le script au démontage
    return () => {
      document.body.removeChild(script);
    };
  }, [channel]);

  /**
   * 3) Rendu du composant
   */
  return (
    <div className="twitch-container">
     {channel ? (
        <>
      <div className="embed-wrapper">
        {/* Le lecteur vidéo Twitch */}
        <div ref={embedRef} className="embed-responsive"></div>

        {/* Overlay pour bloquer ou masquer les clics, comme dans le code 1 */}
        {/* <div className="overlay-block"></div>*/}
      </div>
      </>
      ) : (
        <div>
          <img
            src= {NoLiveImg}
            alt={t("no_live_stream_alt")}
            style={{
            display: 'block',
            margin: '0 auto',
            maxWidth: '35%',
            height: 'auto',
         }}
        />
          <Typography sx={{
            display: 'flex', 
            justifyContent: 'center',  
            alignItems: 'center',   
            fontFamily: 'Arial',
            fontSize: '18px', 
            color: '#b0b0b0', 
            textAlign: 'center', 
            lineHeight: '1.5', 
            margin: '20px 0'
          }}> 
          {t("no_live_stream_now")}
         </Typography>
         </div>
       )}
    </div>
  );
};

export default TeacherTwitchStreamDisplay;
